import React, { useEffect, useState } from 'react';
import Checkbox from 'shared/inputs/BaseCheckbox';
import MultiSelect from 'shared/inputs/BaseMultiSelect';
import FieldsToSelectDropdown from './components/FieldsToSelectDropdown';
import './style.scss';

const OrganizationRolesFilter = ({
  filter, fieldsNameForSearch = [], onFilterChange, data, collection, fieldInfo,
}) => {
  const values = filter.values || [];
  const displayItems = data.filter((x) => values.indexOf(x.value) >= 0) || [];
  const [displayValues, setDisplayValues] = useState(displayItems);
  const [compareWithOtherFieldDisplayValue, setCompareWithOtherFieldDisplayValue] = useState(
    filter.compareWithOtherField ? filter.value : null,
  );
  const [compareWithOtherField, setCompareWithOtherField] = useState(filter.compareWithOtherField);

  const onChange = (event) => {
    const newFilter = {
      ...filter,
      values: event.value.map((x) => x.value),
      fieldInfo,
    };

    delete newFilter.compareWithOtherField;

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setDisplayValues(event.value);
  };

  useEffect(() => {
    setCompareWithOtherField(filter.compareWithOtherField);
  }, [filter.compareWithOtherField]);

  useEffect(() => {
    const setValue = filter.compareWithOtherField ? setCompareWithOtherFieldDisplayValue : setDisplayValues;
    const values = filter.values || [];
    setValue(data.filter((x) => values.indexOf(x.value) >= 0) || []);
  }, [filter.value, filter.values]);

  const handleFieldToCompareChanged = (event) => {
    const value = event.target.value.field;

    const newFilter = {
      ...filter,
      value,
      compareWithOtherField: true,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setCompareWithOtherFieldDisplayValue(event.target.value);
  };

  const handleCompareWithOtherFields = ({ value }) => {
    const newFilter = value
      ? {
        ...filter,
        value:
            typeof compareWithOtherFieldDisplayValue === 'object'
              ? compareWithOtherFieldDisplayValue?.field
              : compareWithOtherFieldDisplayValue,
        compareWithOtherField: true,
        fieldInfo,
      }
      : {
        field: filter.field,
        operator: filter.operator,
        value: typeof displayValues === 'object' ? displayValues?.value : displayValues,
        fieldInfo,
      };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    const setValue = !value ? setCompareWithOtherFieldDisplayValue : setDisplayValues;
    setValue(null);
    setCompareWithOtherField(value);
  };

  return (
    <div className='app-filters-input'>
      {compareWithOtherField && fieldsNameForSearch.length > 0 ? (
        <FieldsToSelectDropdown
          fields={fieldsNameForSearch}
          onFieldChanged={handleFieldToCompareChanged}
          value={compareWithOtherFieldDisplayValue}
        />
      ) : (
        <div className='role-multi-select'>
          <MultiSelect
            onChange={onChange}
            data={data}
            dataItemKey='value'
            textField='description'
            value={displayValues}
          />
        </div>
      )}
      {fieldsNameForSearch.length > 0 && (
        <div className='filter-cbx-wrapper'>
          <Checkbox
            value={compareWithOtherField}
            label='Compare with other field'
            onChange={handleCompareWithOtherFields}
          />
        </div>
      )}
    </div>
  );
};

export default OrganizationRolesFilter;
